export const DISPLAY_STEP = 5;
export const STATE_PENDING = 1;
export const STATE_VALID = 2;
export const STATE_INVALID = 4;
// estimated number of days to validate a payment request
export const PAYMENT_DELAY = 21;



// WEBPACK FOOTER //
// ./src/constants/payment.js